export default __webpack_public_path__ + "static/landing-731ec54ffe29d3e308018c6f7e5602c5.png";